<template>
  <component
    :is="`h${size}`"
    class="c-title"
  >
    <c-icon
      class="icon"
      v-if="icon"
      :icon="icon"
      :height="iconSize"
      :width="iconSize"
    />
    <span class="text"><slot /></span>
  </component>
</template>

<script>
export default {
  props: {
    size: {
      type: [String, Number],
      default: 1
    },
    icon: String,
    iconSize: {
      type: String,
      default: '17'
    }
  }
}
</script>

<style lang="scss">
@import '~@styles/convenia-components/reference.scss';

.c-title {
  margin-top: outer-base(1);
  display: inline-block;
  line-height: 1;

  & > .icon {
    margin-right: 6px;
    vertical-align: bottom;
    fill: #8c92b1 !important;
  }

  & > .text {
    font-weight: 400;
    color: #8c92b1;
    font-family: $c-font-family-title;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CTitle.vue